import { useEffect, useState } from "react";
import { Accordion, Dropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getLabStatusLabel, getStatusLabel, SampleRequestService } from "../../../Services/SampleRequest.Service";
import Loader from "../../../Components/Loader";
import Toaster from "../../../Components/Toaster";
import ConfirmationModal from "../../../Components/ConfirmationModal";
import TokenService from "../../../Services/Token.service";
import RequestorAccordion from "./RequestorAccordion";
import ProjectDetailsAccordion from "./ProjectDetailsAccordion";
import GeneralRequirementAccordion from "./GeneralRequirementAccordion";
import AcknowledgementAccordion from "./AcknowledgementAccordion.js";
import SampleCollectionAppointmentAccordion from "./SampleCollectionAppointementAccordion.js";
import SampleTypeRequestedAccordion from "./SampleTypesRequestedAccordion/SampleTypesRequestedAccordion.js";
import { Helmet } from "react-helmet";
import CancellationNoteModal from "../../../Components/AdministrativeSettings/SampleRequest/CancellationNoteModal.js";
import { DonorService } from "../../../Services/Donor.Service.js";
import NotifyRequestor from "./SampleTypesRequestedAccordion/NotifyRequestor.js";
import DonorSelectionAccordion from "./SampleTypesRequestedAccordion/DonorSelectionAccordion.js";
import InviteSpecialDonorModal from "./InviteSpecialDonorModal.js";
import { FaCircle } from "react-icons/fa";
import PickupDetailsModal from "../../../Components/AdministrativeSettings/SampleRequest/PickupDetailsModal.js";
// import pdf from "../../../Assets/images/requestviewdetails_213.pdf"
function ViewSampleRequestDetails() {

    const [showPickupModal, setShowPickupModal] = useState(false);

    const handleShowPickupModal = () => setShowPickupModal(true);
    const handleClosePickupModal = () => setShowPickupModal(false);

  
    const confirmPickupModal = (values) => {          
        handlePickupDetailsUpdateModal(requestId, values);  
        handleClosePickupModal();
    };
    
    const handlePickupDetailsUpdateModal = async (requestId, values) => {
        try { 
            const payload = {
                request_id : requestId,
                pickup_date : values.pickupDate, 
                pickup_time: values.pickupTime, 
                pickup_by: values.pickedUpBy
            }
        
            const response = await SampleRequestService.updatePickupDetails(payload);
    
            if (response.success) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Sample request pickup details updated successfully:", response);
                setRefreshKey((prevKey) => prevKey + 1); 
            } else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to update sample request pickup details:", error);
        }
    };
    const [selectedRecruitedDonor, setSelectedRecruitedDonor] = useState(null);
    const [acceptedSamples, setAcceptedSamples] = useState([]);
    useEffect(()=>{ 
        if (selectedRecruitedDonor?.accepted_samples) {
            const samplesArray = selectedRecruitedDonor.accepted_samples
                .split(',')
                .map((sample) => Number(sample.trim())); // Convert to array and trim whitespace
            setAcceptedSamples(samplesArray);
        }
        else{
            setAcceptedSamples([]);
        }
    },[selectedRecruitedDonor]);


    const collectSample = async (payload) => {
        setLoading(true);

        const collectSamplePayload = {
            donor_id: selectedRecruitedDonor.donor_id,
            // appointment_id :  selectedRecruitedDonor.appointment_id,
            appointment_id: selectedRecruitedDonor.parent_id,
            request_id: selectedRecruitedDonor.request_id,

            ...payload,
        } 
        try {
            const response = await SampleRequestService.collectSampleType(collectSamplePayload);

            if (response.success === true) {
                SampleRequestService.getSampleRequestDetails(requestId)
                    .then((data) => {
                        setSampleRequestDetails(data);
                        setLoading(false);
                        //updatin selectedRecruitedDonor to hide collect sample request button
                        if (
                            selectedRecruitedDonor?.parent_id &&
                            data?.request?.recruited_donors
                        ) {
                            const donor = data?.request?.recruited_donors.find(
                                (donation) => donation.parent_id === selectedRecruitedDonor.parent_id
                            );
                            if (donor) {
                                setSelectedRecruitedDonor(donor);
                            }
                        }
                    })
                    .catch((err) => {
                        console.error("Error fetching sample type data:", err);
                        setToastMessage(err.response.data.message);
                        setToastVariant('error');
                        setShowToast(true);
                        setLoading(false);
                    });

                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
            } else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }

        } catch (error) {
            setToastMessage("Failed to collect sample type");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to collect sample type:", error);
            setLoading(false);
        }

    }
    const navigate = useNavigate();
    // const sampleAccordionComponents = {
    //     1: <BloodSampleAccordion id={1} />,
    //     2: <UrineAccordion id={2} />,

    //     3: <ExhaledBreathAccordion id={3} />,
    //     4: <SalivaAccordion id={4} />,

    //     5: <BuccalSwabAccordion id={5} />,
    //     6: <HairFollicleAccordion id={6} />,
    //     7: <SkinTapeAccordion id={7} />,
    //     8: <StoolAccordion id={8} />
    // };

    // const [AllSamples, setAllSamples] = useState([]);


    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmCancelRequest = (cancellationNote) => {
        handleCancelRequest(sampleTypeData, cancellationNote);
        handleCloseDeactivateModal();
    };
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        handleDeleteRequest(sampleRequestDetails?.request?.id);
        handleCloseDeleteModal();
    };

    // useEffect(() => {
    //     SampleRequestService.getAllActiveSamplesList()
    //         .then((response) => {
    //             setAllSamples(response.name);
    //         })
    //         .catch((error) => {
    //             console.error("Failed to fetch sample request list", error);
    //             setLoading(false);
    //         });
    // },[])
    // useEffect(() => {
    //     //console.log(AllSamples)
    // }, [AllSamples])

    const [navigateToAdmin, setNavigateToAdmin] = useState(false);
    const handleCancelRequest = async (sample, cancellationNote) => {
     

        setLoading(true);
        const payload = {
            request_id : sample.id,
            cancel_note: cancellationNote,
        }
        try {
            const response = await SampleRequestService.cancelSampleRequest(payload);
             
            
            
            if (response.success === true) {
                setToastMessage(response.message);
                // setShowToast(true);
                setToastVariant('success');
                setNavigateToAdmin(true);
                setLoading(false);
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) {
            setToastMessage("Failed to cancel sample request");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to cancel sample request:", error);
            setLoading(false);
        }
    };
    // UseEffect to handle navigation
    useEffect(() => {
        if (navigateToAdmin) {
            const timer = setTimeout(() => {
                navigate(type !== 'requestor' ?'/admin/sample-requests' : '/requestor/requestor-sample-requests',{state: {
                    toastMessage: toastMessage,
                    toastVariant: 'success',
                }},);
            }, );
            return () => clearTimeout(timer);
        }
    }, [navigateToAdmin]);
    const handleDeleteRequest = async (userId) => {
        try {
            const response = await SampleRequestService.deleteSampleRequest(userId);

            if (response.success === true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');

                setTimeout(() => {
                    navigate('/requestor/requestor-sample-requests');
                }, 2000);
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to delete request draft:", error);
            setToastMessage(error.response.data.message);
            setShowToast(true);
            setToastVariant('error');
        }
    };
    const handleExportPrintRequest = async (userId, type) => {
        setLoading(true);
       try{
            SampleRequestService.exportSampleRequest({request_id: userId, type : type }).then((response)=>{
                if (response.success === true) {
                    setLoading(false);
                    setToastMessage(response.message);
                    setShowToast(true);
                    setToastVariant('success');  
                    const downloadUrl = response.download_url;
                    // const downloadUrl = pdf;
                          
                          const newTab = window.open(downloadUrl, '_blank');

                          if (newTab) { 
                            newTab.onload = () => { 

                                if(type !== 'print') {

                               
                                const link = document.createElement('a');
                                link.href = downloadUrl;
                                // link.setAttribute('download', 'SampleRequest_export.pdf'); 
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);  
                            }
                            else{
                                newTab.print();
                            }
                            };
                        } else {
                            console.error("Unable to open new tab.");
                            setToastMessage('Failed to open PDF for printing.');
                            setToastVariant('error');
                            setShowToast(true);
                        }
                   
                }
                else {
                    setLoading(false);
                    setToastMessage(response.message);
                    setShowToast(true);
                    setToastVariant('error');
                }
            })
            .catch ((error) => { 
                console.error("Failed to duplicate sample request:", error);
                setToastMessage(error.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }) 
        }catch(error){
            console.log(error);
            setLoading(false);
        }
    }
  
    const handleDuplicateRequest = async (userId) => { 
        try { 
            const response = await SampleRequestService.duplicateSampleRequest(userId);

            if (response.success === true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                // setTimeout(() => {
                //     navigate('/requestor/requestor-sample-requests');
                // }, 2000);
                 // Use response.request_id to navigate
                 const { duplicate_id } = response;
                 // const  request_id  = userId;
                //  navigate(`/requestor/request-new-sample`, { state: { id: duplicate_id } });
 
                sessionStorage.setItem('newSampleRequestState', JSON.stringify({ id: duplicate_id }));

            
                const newTabUrl = `/requestor/request-new-sample`;
                window.open(newTabUrl, '_blank');
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) { 
            console.error("Failed to duplicate sample request:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
        }
    };

    const location = useLocation();
    const [sampleTypeData, setSampleTypeData] = useState(location.state?.sampleType);
    const [isCollectSample, setIsCollectSample] = useState(location.state?.isCollectSample);
    const [sampleRequestDetails, setSampleRequestDetails] = useState(null);

    const [type, setType] = useState(location.state?.type);
    const [loading, setLoading] = useState(true);
    // const [error, setError] = useState(null);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const requestId = location.state?.id;

    const [refreshKey, setRefreshKey] = useState(0);
    useEffect(() => {
        if (requestId) { 
            SampleRequestService.getSampleRequestDetails(requestId)
                .then((data) => { 
                    setSampleRequestDetails(data);
                    setLoading(false); 
                })
                .catch((err) => {
                    console.error("Error fetching sample type data:", err);
                    setToastMessage(err.response.data.message);
                    setToastVariant('error');
                    setShowToast(true);
                    setLoading(false);
                });
        } else {
            setLoading(false);

        }
    }, [requestId, refreshKey]);

    const cancelAppointment = async (payload) =>{ 
        setLoading(true);
        if(payload){

            try {
                const result =await  DonorService.cancelDonationAppointment(payload);
                if (result.success === true) { 
                    setToastMessage(result.message);
                    // setShowToast(true);
                    // setToastVariant('success');
                    setNavigateToAdmin(true);
                    console.log("Donation cancelled  successfully:", result);  
                    setLoading(false);
        }
        else {
               // Check if the result.message is an object
               let formattedMessage = ''; 
               if (typeof result.message === 'object' && result.message !== null) {
                   // Convert object to a readable string
                   formattedMessage = Object.keys(result.message)
                   .map((key) => `${key}: ${result.message[key].join(', ')}`)
                   .join(' | ');
                } else {
                    // Use result.message directly if it's not an object
                    formattedMessage = result.message || 'An error occurred.';
                }
                
                setToastMessage(formattedMessage);
                // setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        }catch (error) { 
            console.error("Failed to cancel donation:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
        }
    }
    const [pickupDaysAvailableWRTSampleCount, setPickupDaysAvailableWRTSampleCount] = useState([]);
    const fetchSamplePickupWRTSampleCountList = async () => {
        try {

            // if(selectedSamples != null && selectedSamples.length>0){

            const sample_countt = {
                // count: selectedSamples.length
            }
            SampleRequestService.getPickupListDetails(sample_countt)
                .then(data => {
                    if (data.success) {
                        setPickupDaysAvailableWRTSampleCount(data.pickup);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching sample type data:", err);
                    setToastMessage(err.response.data.message);
                    setToastVariant('error');
                    setShowToast(true);
                    setLoading(false);
                });
            // }
        }
        catch (error) { console.error("Error fetching sample pickup schedule with respect to sample count", error); }
    }
    useEffect(() => {
        fetchSamplePickupWRTSampleCountList(); 
    }, []);
    const donorNotShow = async (payload) => { 
        setLoading(true);
        if (payload) {

            try {
                const result = await DonorService.donorNotShow(payload);
                if (result.success === true) { 
                    setToastMessage(result.message);
                    // setShowToast(true);
                    // setToastVariant('success');
                    setNavigateToAdmin(true);
                    console.log("Donor Not show added sucessfully:", result);
                    setLoading(false);
                }
                else {
                    // Check if the result.message is an object
                    let formattedMessage = '';
                    if (typeof result.message === 'object' && result.message !== null) {
                        // Convert object to a readable string
                        formattedMessage = Object.keys(result.message)
                            .map((key) => `${key}: ${result.message[key].join(', ')}`)
                            .join(' | ');
                    } else {
                        // Use result.message directly if it's not an object
                        formattedMessage = result.message || 'An error occurred.';
                    }

                    setToastMessage(formattedMessage);
                    // setToastMessage(result.message);
                    setShowToast(true);
                    setToastVariant('error');
                    setLoading(false);
                }
            } catch (error) { 
                console.error("Failed to add donor not show:", error);
                setToastMessage(error.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        }
    }
    const updateDonorPunctuality = async (donorPunctual) => {  
        setLoading(true);
        if (donorPunctual) {

            try {
                const result = await DonorService.updateDonorPunctuality(donorPunctual);
                if (result.success === true) { 
                    setToastMessage(result.message);
                    setShowToast(true);
                    setToastVariant('success');
                    // setNavigateToAdmin(true);
                    console.log("Donor punctuality updated sucessfully:", result);
                    setLoading(false);
                }
                else {
                    // Check if the result.message is an object
                    let formattedMessage = '';
                    if (typeof result.message === 'object' && result.message !== null) {
                        // Convert object to a readable string
                        formattedMessage = Object.keys(result.message)
                            .map((key) => `${key}: ${result.message[key].join(', ')}`)
                            .join(' | ');
                    } else {
                        // Use result.message directly if it's not an object
                        formattedMessage = result.message || 'An error occurred.';
                    }

                    setToastMessage(formattedMessage);
                    // setToastMessage(result.message);
                    setShowToast(true);
                    setToastVariant('error');
                    setLoading(false);
                }
            } catch (error) { 
                console.error("Failed to update donor punctuality:", error);
                setToastMessage(error.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        }
    }
    const previousUrl = TokenService.getPrevLink();

    const [completedDonorDetails , setCompletedDonorDetails] = useState();
    useEffect(()=>{
        if(requestId && sampleRequestDetails){ 
            getCollectedSampleCount();
        }
    },[requestId, sampleRequestDetails]);

    const getCollectedSampleCount = async( )=>{ 
        try {
            const result = await DonorService.getCollectedSampleCount({request_id :requestId});
            if (result.success === true) { 

                setCompletedDonorDetails(result.collected);
                // setToastMessage(result.message);
                // setShowToast(true);
                // setToastVariant('success');
                // setNavigateToAdmin(true);
                console.log("Donor punctuality updated sucessfully:", result);
                setLoading(false);
            }
            else {
                // Check if the result.message is an object
                let formattedMessage = '';
                if (typeof result.message === 'object' && result.message !== null) {
                    // Convert object to a readable string
                    formattedMessage = Object.keys(result.message)
                        .map((key) => `${key}: ${result.message[key].join(', ')}`)
                        .join(' | ');
                } else {
                    // Use result.message directly if it's not an object
                    formattedMessage = result.message || 'An error occurred.';
                }

                setToastMessage(formattedMessage);
                // setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) { 
            console.error("Failed to update donor punctuality:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
    }


    const notifyRequestor = async (payload)  =>{ 
        setLoading(true);
        try {
            const result = await SampleRequestService.notifyPickup(payload);
            if (result.success === true) { 
                setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('success');
                // setNavigateToAdmin(true);
                console.log("Requestor Notified sucessfully:", result);
                setLoading(false);
            }
            else {
                // Check if the result.message is an object
                let formattedMessage = '';
                if (typeof result.message === 'object' && result.message !== null) {
                    // Convert object to a readable string
                    formattedMessage = Object.keys(result.message)
                        .map((key) => `${key}: ${result.message[key].join(', ')}`)
                        .join(' | ');
                } else {
                    // Use result.message directly if it's not an object
                    formattedMessage = result.message || 'An error occurred.';
                }

                setToastMessage(formattedMessage);
                // setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) { 
            console.error("Failed to notify requestor:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
    }

    const [showSelectSpecialDonorModal, setShowSelectSpecialDonorModal] = useState(false);

    const handleShowSelectSpecialDonorModal = () => setShowSelectSpecialDonorModal(true);
    const handleCloseSelectSpecialDonorModal = () => setShowSelectSpecialDonorModal(false);

    const confirmSelectSpecialDonor = async (payload) => {
        
        handleCloseSelectSpecialDonorModal();
        setLoading(true);
        try {
            const result = await SampleRequestService.unassignedDonors(payload);
            if (result.success) { 
                setLoading(false);
                setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('success');
                setRefreshKey((prevKey) => prevKey + 1); 

                // setNavigateToAdmin(true);
                console.log("Requestor Notified sucessfully:", result);
            }
            else {
                // Check if the result.message is an object
                let formattedMessage = '';
                if (typeof result.message === 'object' && result.message !== null) {
                    // Convert object to a readable string
                    formattedMessage = Object.keys(result.message)
                        .map((key) => `${key}: ${result.message[key].join(', ')}`)
                        .join(' | ');
                } else {
                    // Use result.message directly if it's not an object
                    formattedMessage = result.message || 'An error occurred.';
                }

                setLoading(false);
                setToastMessage(formattedMessage);
                // setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) { 
            console.error("Failed to notify requestor:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
  
    };
    const selectSpecialDonor = async () =>{
        handleShowSelectSpecialDonorModal()
    }
    return (
        <>  
            <Helmet>
                <title>DonorX | Sample Request - {isCollectSample === true ? "Collect": "View Details"}</title>
            </Helmet>
            <Loader loading={loading} /> 
            {/* <h1>{sampleTypeData.id}</h1>  */}
            <div className="el-middle-wrapper">
                <h2 className="el-title">  {isCollectSample === true ? (
                                        <>
                                        Collect Samples
                                        </> ) : <>
                                        Sample Request Details
                                        </>}</h2>

                                        {isCollectSample === true ? 
                                        (<> 
                                            <Link className="back-link" onClick={()=>setIsCollectSample(false)}  as={Link} to={`/admin/sample-requests/viewdetails`} state={{ sampleType : sampleTypeData, type, id: requestId } }><i className='el-icon-back'></i> Request Detail Page</Link>
                                        </>) : 
                                        (<> 
                                            <Link className="back-link" to={`${ previousUrl !='/admin/donor-management' ?  previousUrl : '/admin/sample-requests'  || `/${type !== 'requestor' ? 'admin' : 'requestor'}/${type !== 'requestor' ? 'sample-requests' : 'requestor-sample-requests'}`}`}><i className='el-icon-back'></i> Sample Requests</Link>
                                        </>)}
                <div className="el-profile-board p-3 ely-sample-request-details mt-3">
                    <div className="d-flex justify-content-between align-items-center px-3 mb-4">
                        <div className="d-flex"> 
                            <div className="">
                                {type === 'requestor' ? (
                                <>
                                        <div className="d-flex">
                                        <div>
                                            <h3><span className={`${sampleRequestDetails?.request?.lab_status === 4 ? 'text-bg-danger' : "text-bg-success"} badge  `}> <FaCircle className="me-1 fa-dot" />   {getLabStatusLabel(sampleRequestDetails?.request?.lab_status)}</span></h3>
                                        </div>
                                        {sampleRequestDetails?.request?.status !== 4  && (
                                            <>
                                            <div className="ms-2">
                                                <h3><span className={`${sampleRequestDetails?.request?.status === 4 ? 'text-bg-danger' : sampleRequestDetails?.request?.status === 2 ? "text-bg-success" : "li-sl-bg-blue"} badge`}>  <FaCircle className="me-1 fa-dot" /> 
                                                {sampleRequestDetails?.request?.status === 1 || sampleRequestDetails?.request?.status === 5 || sampleRequestDetails?.request?.status === 6 || sampleRequestDetails?.request?.status === 7
                                                    ? 'Submitted'
                                                    : sampleRequestDetails?.request?.status === 8
                                                        ? 'Completed'
                                                        : getStatusLabel(sampleRequestDetails?.request?.status, type)}</span></h3>
                                            </div>
                                            </>
                                        )}
                                                            </div>
                                                </>
                                ) : (

                                    <h3><span className={`${sampleRequestDetails?.request?.status === 4 ? 'text-bg-danger' : "text-bg-success"} badge  `}>  <FaCircle className="me-1 fa-dot" /> {getStatusLabel(sampleRequestDetails?.request?.status, type)}</span></h3>
                                )}


                            </div>
                        </div>
                        <div className="d-flex justify-content-around">
                            {isCollectSample !== true && !(type!=='requestor' && sampleRequestDetails?.request?.status === 4)  && (
                                <>
                            <Dropdown>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    <i className="el-icon-sort me-2"></i> Action
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="el-admins">
                                    {type !== 'requestor' && (sampleRequestDetails?.request?.status !== 4 )  && (
                                        <Dropdown.Item  onClick={()=>setIsCollectSample(true)}  as={Link} to={`/admin/sample-requests/collectsamples`} state={{ sampleType :sampleTypeData, type,  id : requestId, isCollectSample : true} } >
                                            Collect Sample
                                        </Dropdown.Item>
                                    )}
                                    {(type !== 'requestor' && (sampleRequestDetails?.request?.status === 7 || sampleRequestDetails?.request?.status === 8)) && (
                                        <Dropdown.Item
                                            data-bs-toggle="modal"
                                            data-bs-target="#markpickedup"
                                            onClick={handleShowPickupModal}
                                        >
                                            Mark "Picked Up"
                                        </Dropdown.Item>
                                    )}

                                   
                                    {/* && sampleTypeData.status !== 5 */}
                                    {(type === 'requestor' ) && (
                                        <>
                                         <Dropdown.Item onClick={()=>{handleExportPrintRequest(sampleRequestDetails?.request?.id , 'export')}}  >
                                                <label >{'Export'}</label>
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={()=>{handleExportPrintRequest(sampleRequestDetails?.request?.id, 'print')}}  >
                                                <label >{'Print'}</label>
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleDuplicateRequest(sampleRequestDetails?.request?.id)}  >
                                                <label >{'Duplicate'}</label>
                                            </Dropdown.Item>
                                        </>
                                    )}
                                     {![7, 8, 4, 0].includes(sampleRequestDetails?.request?.status) && (
                                        <Dropdown.Item
                                            onClick={handleShowDeactivateModal}
                                            className="text-danger"
                                            data-bs-toggle="modal"
                                            data-bs-target="#CancelRequest"
                                        >
                                            Cancel Request
                                        </Dropdown.Item>
                                    )}
                                    {(type === 'requestor' && sampleRequestDetails?.request?.status === 0) && (
                                        <>
                                            <Dropdown.Item onClick={handleShowDeleteModal}>
                                                <label >{'Delete'}</label>
                                            </Dropdown.Item> </>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                                
                                </>
                            ) }
                        </div>

                    </div>
                    <div className="el-card-content el-custom-accordion">
                        <div className="d-sm-flex align-items-md-center">
                            <div className="el-property-details-card-content ">

                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                <Accordion alwaysOpen defaultActiveKey={["0","1","2","3","4","5","6", "7"]} flush>
                                    <RequestorAccordion sampleRequestDetails={sampleRequestDetails}></RequestorAccordion>

                                    <ProjectDetailsAccordion type={type} isCollectSample={isCollectSample} sampleRequestDetails={sampleRequestDetails}> </ProjectDetailsAccordion>

                                    <GeneralRequirementAccordion sampleRequestDetails={sampleRequestDetails}> </GeneralRequirementAccordion>
                                    {isCollectSample === true && (
                                        <>
                                            <DonorSelectionAccordion  sampleRequestDetails={sampleRequestDetails} sampleTypeData={sampleTypeData} donorNotShow={donorNotShow} updateDonorPunctuality={updateDonorPunctuality} selectedRecruitedDonor={selectedRecruitedDonor} setSelectedRecruitedDonor={setSelectedRecruitedDonor} selectSpecialDonor={selectSpecialDonor} />
                                        </>
                                    )}
                                    <SampleTypeRequestedAccordion  type={type} sampleRequestDetails={sampleRequestDetails} sampleTypeData={sampleTypeData} cancelAppointment={cancelAppointment} isCollectSample={isCollectSample}  selectedRecruitedDonor={selectedRecruitedDonor}  acceptedSamples={acceptedSamples} collectSample={collectSample} > </SampleTypeRequestedAccordion>

                                    {isCollectSample !== true && (
                                        <>
                                        <AcknowledgementAccordion sampleRequestDetails={sampleRequestDetails} />

                                        <SampleCollectionAppointmentAccordion type={type} sampleRequestDetails={sampleRequestDetails}  pickupDaysAvailableWRTSampleCount = {pickupDaysAvailableWRTSampleCount}/>
                                        
                                        </>
                                    )}
                                    {isCollectSample === true && (
                                        <>
                                            <NotifyRequestor sampleRequestDetails={sampleRequestDetails}  completedDonorDetails={completedDonorDetails} notifyRequestor={notifyRequestor}/>
                                        </>
                                    )}
                                </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />

                        {/* cancel sample request  */}

             
            <CancellationNoteModal
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmCancelRequest}
                title="Cancel Request"
            />
            {/* cancel sample request  */}
            {/* <ConfirmationModal
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmDeactivateUser}
                title=""
                body={`Are you sure you want to cancel sample request?`}
                type='deactivateactivate'
            /> */}
  {/* Delete sample request  */}
            <InviteSpecialDonorModal
                show={showSelectSpecialDonorModal}
                onHide={handleCloseSelectSpecialDonorModal}
                onConfirm={confirmSelectSpecialDonor} 
                id={requestId}
                 ismatched={sampleRequestDetails?.request?.matched_sample}
            />

            {/* Delete sample request  */}
            <ConfirmationModal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onConfirm={confirmDeleteUser}
                title=""
                body={`Are you sure you want to delete?`}

            />
               {/* Delete sample request  */}
               { showPickupModal && (<> 
                    <PickupDetailsModal
                        show={showPickupModal}
                        onHide={handleClosePickupModal}
                        onConfirm={confirmPickupModal}  
                        request_id = {requestId}
                        // duration={sampleType.sample_collect_duration}
                        sample_count={sampleRequestDetails?.request?.sample_ids?.split(',').map(id => parseInt(id.trim())).length} 
                        status ={sampleRequestDetails?.request?.status}
                        sample={sampleRequestDetails?.request}
                    />
               </>)}
        </>
    );
}


export default ViewSampleRequestDetails